import { Outlet } from "react-router-dom";

const HideNav = () => {
  return (<Outlet />)
}

export default HideNav;